import { render } from "./examButton.vue?vue&type=template&id=1c923358&scoped=true"
import script from "./examButton.vue?vue&type=script&lang=js"
export * from "./examButton.vue?vue&type=script&lang=js"

import "./examButton.vue?vue&type=style&index=0&id=1c923358&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/CIS-school.vip.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c923358"]])

export default __exports__